<template>
    <div
        class="d-form-row"
        :class="{'vertical': isVertical}"
    >
        <div
            class="label"
            :class="{'required': isRequired}"
        >
            {{ label ?? $t('common.label_missing') }}
        </div>
        <div class="content">
            <div class="input">
                <slot />
            </div>
            <div
                v-if="hint"
                class="hint"
            >
                {{ hint }}
            </div>
            <div
                v-if="error"
                class="error"
            >
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DFormRow',
    props: {
        label: {
            type: String,
            required: true,
            default: null
        },
        isRequired: {
            type: Boolean,
            required: false,
            default: false
        },
        isVertical: {
            type: Boolean,
            required: false,
            default: false
        },
        hint: {
            type: String,
            required: false,
            default: ''
        },
        error: {
            type: String,
            required: false,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.d-form-row {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 10px 15px;

    &.vertical {
        grid-template-columns: 1fr;
        grid-gap: 5px 15px;
    }

    & .label {
        grid-column: 1;
        font-weight: bold;
        padding: 10px 0px;

        &.required::after {
            content: "*";
            color: var(--colorDanger);
        }
    }
    & .content {
        display: grid;
        grid-gap: 5px;
        align-items: center;

        & .input {
            & .form-group {
                margin: 0;
            }
        }

        & .error {
            font-size: 12px;
            color: var(--colorDanger);
        }

        & .hint {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.6);
        }
    }

    &:not(:last-child) {
        margin-bottom: 25px;
    }
}
</style>
